<template>
  <m-form
    :title="title"
    :items="items"
    :cols="cols"
    :canSubmit="false"
    :can-edit="false"
    :list-export-base-url="printUrl"
    :exportParams="{id: item.id}"
    :canDelete="false"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
  >
    <template #default>
      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import WareApiMixin from "@/mixin/wareApi";
import { MFormMixin } from "@/components/m-form";

export default {
  mixins: [MFormMixin, WareApiMixin],
  data() {
    return {
      filters: {},
      printUrl: 'reports/unit/all',
      item: {},
      baseUrl: "wares/units",
      permissionBasename: "unit",
      cols: [
        {
          text: "نام",
          value: "name",
          type: "text",
          filters: ["name"]
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
          filters: ["explanation"]
        }
      ]
    };
  },
  computed: {
    title(){
      return this.setDocumentTitle('تعریف واحد شمارش کالا')
    },
    items() {
      return this.units;
    }
  },
  methods: {
    getData() {
      this.getUnits(true);
    }
  }
};
</script>